module.exports = __webpack_public_path__ + "img/like-icon.f11fe57a.svg";